import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import api from "../../services/api"
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material"
import PostsGrid from "./PostGrid"

function ModalPosts({ selectedConnection, open, handleClose, handleConfirm }) {
    const [data, setData] = useState([])
    const [afterCursor, setAfterCursor] = useState(null)
    const [loading, setLoading] = useState(false)
    // const [hasMore, setHasMore] = useState(true)

    const getPosts = async () => {
        try {
            setLoading(true)
            const response = await api.get(
                `/automation/posts/${selectedConnection}/?afterCursor=${afterCursor}`,
            )

            const newData = response.data.data
            // setData([...data, ...newData])
            setData(newData)
            setAfterCursor(response.data.paging.cursors.after)

            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao buscar posts")
        }
    }

    useEffect(() => {
        if (selectedConnection) {
            getPosts()
        }
    }, [selectedConnection])

    const [selectAll, setSelectAll] = useState(true)
    const [selected, setSelected] = useState(data.map((item) => item.id))

    const handleChangeSelectedPosts = (id) => {
        if (selected.includes(id)) {
            setSelected(selected.filter((item) => item !== id))
            setSelectAll(false)
        } else {
            setSelected([...selected, id])
        }
    }

    useEffect(() => {
        if (selectAll) {
            setSelected(data.map((item) => item.id))
        }
    }, [selectAll])

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Selecionar posts</DialogTitle>

            <DialogContent>
                <input
                    id="select-all"
                    type="checkbox"
                    style={{
                        cursor: "pointer",
                    }}
                    checked={selectAll}
                    onClick={() => setSelectAll(!selectAll)}
                />
                <label
                    htmlFor="select-all"
                    style={{
                        cursor: "pointer",
                    }}
                >
                    Selecionar todos
                </label>

                <PostsGrid
                    data={data}
                    selected={selected}
                    handleChange={handleChangeSelectedPosts}
                    selectAll={selectAll}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        handleConfirm({
                            selectAll,
                            selected: data.filter((item) =>
                                selected.includes(item.id),
                            ),
                        })
                        handleClose()
                    }}
                    disabled={loading}
                    loading={loading}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalPosts
